import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { RootState } from '../';
import { AzureMonitoringService } from '../../services/AzureMonitoringService';
import { RelocationRestService } from '../../services/rest/relocation.rest.service';
import { AbstractEffects } from '../AbstractEffects';
import * as actions from './relocations.actions';
import { catchError, debounceTime, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { NotificationService } from 'app/core/services/notification.service';

@Injectable({ providedIn: 'root' })
export class RelocationsEffects extends AbstractEffects {
  loadRelocations$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.RELOCATIONS_LOAD),
      debounceTime(50), // Avoid double click
      withLatestFrom(this.store, (action, state) => {
        return { state };
      }),
      switchMap(({ state }) =>
        this.relocationRestService.getRelocations(state.relocations.filter).pipe(
          map(
            relocations =>
              new actions.RelocationsLoadSuccessAction({
                relocations,
                definitions: state.definitions,
                places: state.definitions.places,
              })
          ),
          catchError(err => this.handleFail(err, 'ERRORS.FILTER_FAILED.TITLE', [of(new actions.RelocationsLoadFailAction(err))]))
        )
      )
    )
  );

  constructor(
    private store: Store<RootState>,
    azureMonitoringService: AzureMonitoringService,
    private actions$: Actions,
    private relocationRestService: RelocationRestService,
    translateService: TranslateService,
    notificationService: NotificationService
  ) {
    super(translateService, azureMonitoringService, notificationService);
  }
}
